<style lang="scss" scoped="">

  .header-list {
    overflow: hidden;
  }

  .opera-btn-group {
    margin-left: 0;
    margin-right: 0;
  }

  .el-col {
    word-wrap: break-word;
    word-break: break-all;
  }
</style>
<template>
  <div class="order-page">
    <div>
      <search-part :bizTypes="bizTypes" @search="search" v-show="!isOrder"/>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="3" style="padding-left: 2px" v-show="!isOrder">货主订单号</el-col>
          <el-col :span="5">推送单位</el-col>
          <el-col :span="4">推送地址</el-col>
          <el-col :span="isOrder ? 7:4 ">推送返回结果</el-col>
          <el-col :span="3">推送类型</el-col>
          <el-col :span="2">推送状态</el-col>
          <el-col :span="3">推送时间</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!logList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div v-else="" class="order-list-body flex-list-dom">
          <div class="order-list-item order-list-item-bg order-list--no" v-for="(item, index) in logList"
               :key="item.id"
               @click.prevent="showItem(item)"
               :class="['status-no',{'active':currentItemId===item.id}]">
            <el-row>
              <el-col :span="3" v-show="!isOrder">
                {{item.orderNo }}
              </el-col>
              <el-col :span="5">
                {{item.orgName }}
              </el-col>
              <el-col :span="4">
                {{item.address }}
              </el-col>
              <el-col :span="isOrder ? 7:4 ">
                <div style="max-height: 200px;overflow: auto">
                  {{item.result }}
                </div>
              </el-col>
              <el-col :span="3">
                {{item.typeTitle }}
              </el-col>
              <el-col :span="2">
                {{item.status }}
              </el-col>
              <el-col :span="3">
                {{item.pushTime | time}}
              </el-col>
            </el-row>
            <!--<div class="order-list-item-bg"></div>-->
          </div>
        </div>
      </div>
      <div class="text-center" v-show="logList.length && !loadingData">
        <el-pagination
          layout="sizes, prev, pager, next, jumper"
          :total="pager.count" :pageSize="pager.pageSize" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10,20,50,100]" :current-page="pager.currentPage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/jsx">
  import validMixin from '@/mixins/vaildMixin';
  import SearchPart from './search';
  import orderMixin from '@/mixins/orderMixin';
  import utils from '@/tools/utils';

  export default {
    props: {
      orderId: String,
      index: Number
    },
    components: {SearchPart},
    mixins: [validMixin, orderMixin],
    data() {
      return {
        loadingData: true,
        showDetailPart: false,
        orgType: {},
        filters: {},
        logList: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 10
        },
        currentItemId: '',
        currentItem: {}
      };
    },
    mounted() {
      !this.isOrder && this.getGoodsList(1);
      this.orgType = utils[this.type === 0 ? 'inBspOrderType' : 'outBspOrderType'];
    },
    computed: {
      isOrder() {
        return this.orderId;
      },
      span() {
        return this.isOrder ? 1 : 0;
      }
    },
    watch: {
      role() {
        this.getGoodsList(1);
      },
      index(val) {
        if (val !== 4) return;
        this.getGoodsList(1);
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getGoodsList(1);
      },
      handleCurrentChange(val) {
        this.getGoodsList(val);
      },
      getGoodsList(pageNo) {
        this.logList = [];
        this.pager.currentPage = pageNo;
        let params = Object.assign({
          objectId: this.orderId,
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        }, this.filters);
        this.loadingData = true;
        this.$http.get('/bsp-push-log', {params}).then(res => {
          this.logList = res.data.list;
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
      },
      search(val) {
        Object.assign(this.filters, val);
        this.getGoodsList(1);
      }
    }
  };
</script>
